import "./App.css";
// import AboutCapitalAcres from "./components/AboutCapitalAcres";
import AboutDeveloper from "./components/AboutDeveloper";
import Amenities from "./components/Amenities";
import BestQuotes from "./components/BestQuotes";
import Carousel from "./components/Carousel";
import Details from "./components/Details";
import DigitalCopy from "./components/DigitalCopy";
import FloorPlan from "./components/FloorPlan";
import Footer from "./components/Footer";
import Form from "./components/Form";
import Header from "./components/Header";
import Hero from "./components/Hero";
// import InfoBox from "./components/InfoBox";
import StripSection from "./components/StripSection";
import VirtualTour from "./components/VirtualTour";
import VirtualTourRequest from "./components/VirtualTourRequest";
import Pricing from "./components/Pricing";
import NewForm from "./components/NewForm";
import { useEffect } from "react";
import Cc from "./components/Cc";
import Modal1 from "./components/Modal1";

function App() {
  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => e.preventDefault();

    // Disable F12 and Ctrl+Shift+I
    const handleKeyDown = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey &&
          e.shiftKey &&
          (e.key.toLowerCase() === "i" || e.key.toLowerCase() === "c"))
      ) {
        e.preventDefault();
      }
    };

    // Attach event listeners
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup event listeners
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []); // Empty array means it runs once on mount
  return (
    <div className="App">
      <Header />
      <Hero />
      <NewForm />
      {/* <InfoBox /> */}
      <StripSection />
      <Details />
      <Cc />
      <VirtualTour />
      <Pricing />
      <FloorPlan />
      <Amenities />
      <VirtualTourRequest />
      <Carousel />
      <DigitalCopy />
      <AboutDeveloper />
      {/* <AboutCapitalAcres /> */}
      <BestQuotes />
      <Modal1 />
      <Footer />
      <Form />
    </div>
  );
}

export default App;
